import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import moment from "moment";
import { withRouter } from "react-router";

class MobilePaymentHistory extends Component {
  render() {
    const { payments } = this.props;
    console.log(payments);
    return (
      <Grid container spacing={1}>
        {payments.map((payment, index) => (
          <Grid item xs={12} sm={12} md={12} key={index}>
            <Paper
              style={{ display: "flex", padding: 10 }}
              onClick={() =>
                this.props.history.push(`/payment/details/${payment._id}`)
              }
            >
              <div style={{ flexGrow: 1 }}>
                <b>{payment.itemDetails[0].title}</b>
                <div>Paid By {payment.payVia}</div>
                <div>{moment(payment.createdAt).format("LL")}</div>
              </div>
              <div>
                {payment.payVia === "khalti" ? (
                  <b>Rs. {payment.totalPrice} /-</b>
                ) : (
                  <b>$ {payment.totalPrice}</b>
                )}
              </div>
            </Paper>
          </Grid>
        ))}
      </Grid>
    );
  }
}

export default withRouter(MobilePaymentHistory);
